import React from "react";


export default function OnMoving(){
  return <div className="on-moving alert alert-info text-center p-3 w-100 mb-0">Wstaw tutaj</div>;
}